import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { ReactNode } from "react";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";

interface ProvidersProps {
  children: ReactNode;
}

function HeroUIThemedProvider({ children }: { children: ReactNode }) {
  const { theme } = useTheme();
  return (
    <HeroUIProvider navigate={undefined} locale={undefined} {...({ theme } as any)}>
      <ToastProvider
        placement="top-right"
        toastOffset={24}
        toastProps={{
          color: "default",
          variant: "bordered",
          radius: "sm",
          timeout: 3000,
          shouldShowTimeoutProgress: false,
          classNames: {
            base: "w-full sm:max-w-[356px] max-w-[calc(100vw-24px)]",
            wrapper: "gap-y-0.5",
            icon: "shrink-0",
            title: "text-[var(--text-main)] dark:text-white text-sm font-semibold",
            description: "!text-[var(--text-muted)] dark:!text-white/80",
          },
        }}
        maxVisibleToasts={3}
      />
      {children}
    </HeroUIProvider>
  );
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider>
      <HeroUIThemedProvider>{children}</HeroUIThemedProvider>
    </ThemeProvider>
  );
}
